import { render, staticRenderFns } from "./BusinessSidebar.vue?vue&type=template&id=e9bd178a&scoped=true"
import script from "./BusinessSidebar.vue?vue&type=script&lang=js"
export * from "./BusinessSidebar.vue?vue&type=script&lang=js"
import style0 from "./BusinessSidebar.vue?vue&type=style&index=0&id=e9bd178a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bd178a",
  null
  
)

export default component.exports